export enum OrderState {
    NotApplicable = 'NotApplicable',
    NotProcessed = 'NotProcessed',
    Processed = 'Processed',
}
